import { putCustomerRule } from '../services';
export const putRule = (id, name, slot, enableOverload, content) => putCustomerRule(id, name, slot, enableOverload, content).then(response => response?.data);
